import LoginFormConsignado from "@/components/Flows/Consignado/LoginFormConsignado";
import LoginFormCorbanAuth from "@/components/Flows/AuthCorban/LoginFormCorbanAuth";
import LoginFormFgts from "@/components/Flows/Fgts/LoginFormFgts";
import TabNavigator from "@/components/TabNavigator";
import TabNavigatorConsignado from "@/components/Flows/Consignado/TabNavigatorConsignado";
import { Proposal } from "@/models/proposal.model";
import { ProposalConsignado } from "@/models/proposalConsignado.model";

export type FlowType = "fgts" | "consignado" | "autenticacao";
export type AnyProposal = Proposal | ProposalConsignado;

export const flows: Record<FlowType, {
  loginPath: (shorthash: string) => string;
  firstPath: (shorthash: string) => string;
  hasTabs: boolean;
  tabsComponent: React.ReactNode;
  loginForm: (shorthash: string) => React.ReactNode;
}> = {
  fgts: {
    loginPath: (shorthash) => `/${shorthash}`,
    firstPath: (shorthash) => `/${shorthash}/dados-pessoais`,
    hasTabs: true,
    tabsComponent: <TabNavigator />,
    loginForm: (shorthash) => <LoginFormFgts shorthash={shorthash} />,
  },
  consignado: {
    loginPath: (shorthash) => `/${shorthash}`,
    firstPath: (shorthash) => `/${shorthash}/consignado/geolocalizacao`,
    hasTabs: true,
    tabsComponent: <TabNavigatorConsignado />,
    loginForm: (shorthash) => <LoginFormConsignado shorthashId={shorthash} />,
  },
  autenticacao: {
    loginPath: (shorthash) => `/${shorthash}`,
    firstPath: (shorthash) => `/${shorthash}/plat/geolocalizacao`,
    hasTabs: false,
    tabsComponent: null,
    loginForm: (shorthash) => <LoginFormCorbanAuth shortHashId={shorthash} />,
  },
};

export function resolveFlowType(shorthash?: string): FlowType {
  if (shorthash?.startsWith("consig_")) return "consignado";
  // "plat" é o marcador do fluxo de autenticação (sem shortHash). Mantém o prefixo
  // "plat_" antigo por compatibilidade com links já gerados.
  if (shorthash === "plat" || shorthash?.startsWith("plat_")) return "autenticacao";
  return "fgts";
}
